export default __webpack_public_path__ + "static/research-a992f099e362ce5ade8ad1d046c82a6f.png";